export const DATETIME_FORMAT = "DD MMM - HH:mm";
export const V5_IRRIGATING_STATUSES = [4, 6, 26, 33];
